export enum ResolvableServiceUsagesActionKind {
  ClearState = 'clearState',
  StartCreate = 'startCreate',
  StartFlushAll = 'startFlushAll',
  StartFlushOne = 'startFlushOne',
  StartCustomizeAll = 'startCustomizeAll',
  StartCustomizeOne = 'startCustomizeOne',
  StartRemove = 'startRemove',
  StartUpdate = 'startUpdate',
  EndCreate = 'endCreate',
  EndFlushAll = 'endFlushAll',
  EndFlushOne = 'endFlushOne',
  EndCustomizeAll = 'endCustomizeAll',
  EndCustomizeOne = 'endCustomizeOne',
  EndRemove = 'endRemove',
  EndUpdate = 'endUpdate',
}
